"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowsLoading = void 0;
var react_1 = __importDefault(require("react"));
var design_system_loaders_1 = require("@contrast-security-inc/design-system-loaders");
var shared_1 = require("./shared");
var TableRowsLoading = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? [] : _b, _c = _a.pageSize, pageSize = _c === void 0 ? 10 : _c, testId = _a.testId;
    return (react_1.default.createElement(react_1.default.Fragment, null, __spreadArray([], Array(pageSize), true).map(function (_, rowIndex) { return (react_1.default.createElement("tr", { key: "loading-row-".concat(rowIndex), "data-testid": "".concat(testId, "-row-loading-").concat(rowIndex) }, columns.map(function (column, cellIndex) { return (react_1.default.createElement("td", { key: "loading-cell-".concat(cellIndex), "data-testid": "".concat(testId, "-cell-loading-").concat(rowIndex, "-").concat(cellIndex) }, column.id !== shared_1.COLUMN_IDS.expand ? (react_1.default.createElement(design_system_loaders_1.Skeleton, { shape: "rectangle", height: 24, borderRadius: 2 })) : undefined)); }))); })));
};
exports.TableRowsLoading = TableRowsLoading;
